import * as Routes from 'constants/Routes'
import { injectReducer } from 'common/reducers'
import { loadDashboardContainer, loadDashboardReducer } from './dashboardPreload'

export default store => ({
  path: Routes.DASHBOARD,
  getComponent: async function (nextState, cb) {
    const [module, reducer] = await Promise.all([loadDashboardContainer(), loadDashboardReducer()])

    injectReducer(store, { key: 'dashboard', reducer: reducer.default })

    cb(null, module.default)
  }
})
